import React from "react";
const SearchDropdown = (props) => {
    var _a, _b;
    const [open, SetOpen] = React.useState(false);
    const handleOpen = () => {
        SetOpen(!open);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "search-dropdown-genblock" },
            React.createElement("label", { onClick: handleOpen, className: `dropdown-title d-space-between DMSanN_14_400 ${open
                    ? "txt-midnight-blue bg_aqua_white"
                    : "txt_secondary-gray bg_white"}` },
                props.title,
                React.createElement("span", { className: `edel-icon-arrow-down ${open ? "rotate txt-midnight-blue" : "txt-midnight-blue"}` })),
            open && (React.createElement("div", { className: "dropdown-list" }, ((_a = props.list) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                ((_b = props.list) === null || _b === void 0 ? void 0 : _b.map((item) => {
                    var _a;
                    return (React.createElement("div", { key: item.value, className: "d-flex" },
                        React.createElement("input", { className: "form-check-input", type: "checkbox", value: item.value, name: props.name, checked: ((_a = props.selected) === null || _a === void 0 ? void 0 : _a.findIndex((x) => x === item.value)) > -1, onChange: props.onChange }),
                        React.createElement("span", { className: "DMSanN_14_400 txt_blackOne1 pdl-10" }, item.display)));
                })))))));
};
export default SearchDropdown;
